module.exports = __webpack_public_path__ + "img/ffda420.jpg";